import { useQuery } from '@tanstack/react-query'
import { useSearchParams } from 'react-router-dom'
import { getUserCourses as queryFn } from '../../infrastructure/api-signup'
import { useToken } from '../useToken'
import { extendCourseData } from '../../helpers/courses'
import { calculateResilientBackoff, shouldRetryResilient } from '../../helpers/resilience'

export const useUserCourses = () => {
    const { _id, _classId } = useToken()

    const queryKey = ['User', _id, 'Courses']

    const { data: rawCourses, ...rest } = useQuery({
        queryKey,
        queryFn,
        // Estrategia de resiliencia para endpoint crítico GET /v1/users/courses
        // Configurado para sobrevivir la "ventana de muerte" de 50s durante reinicios de pods
        retry: shouldRetryResilient,
        retryDelay: calculateResilientBackoff,
    })

    const courses = rawCourses?.map(extendCourseData)

    const getCourseData = (slugOrId?: string) => courses?.find(course => course.courseId === slugOrId)

    const currentCourse = getCourseData(_classId)

    const currentCourseName = currentCourse?.networkName ?? currentCourse?.courseName

    return {
        courses,
        currentCourse,
        currentCourseName,
        getCourseData,
        ...rest,
    }
}

export const useUserCourse = (slugOrId?: string) => {
    const { courses, ...rest } = useUserCourses()
    const [searchParams] = useSearchParams()
    const profileIdParam = searchParams.get('profileId')

    // If there is a profileId in the URL, search by slug/courseId AND profileId to disambiguate
    // cohorts with the same slug but different profileId
    const course = courses?.find(({ courseId, slug, profileId }) => {
        const matchesSlugOrId = slug === slugOrId || courseId === slugOrId
        if (profileIdParam) {
            return matchesSlugOrId && profileId === profileIdParam
        }
        return matchesSlugOrId
    })

    return { course, courseId: course?.courseId, courseSlug: course?.slug, ...rest }
}
